export default __webpack_public_path__ + "static/media/l_wdt_c_0.af54803d.mp3";